<template>
  <div class="merge-request-auto-merge-info__wrapper mb-3">
    <div class="d-flex align-items-center p-2 px-3 flex-wrap">
      <span
        v-if="mergeRequest.autoMergeEnabled"
        class="d-flex align-items-center font-weight-bolder mr-1"
      >
        <i class="gf-icon gf-icon-git-branch mr-2"></i>
        <span v-html="$t('page.titleAutoMergeEnabled')"></span>
      </span>

      <span
        v-else
        class="d-flex align-items-center font-weight-bolder mr-1"
      >
        <i class="gf-icon gf-icon-git-branch mr-2"></i>
        <span v-html="$t('page.titleAutoMergeDisabled')"></span>
      </span>

      <user-label-item
        v-if="mergeRequest.autoMergeEnabled"
        class="text-nowrap"
        :user="user"
        :has-user-link="true"
        :show-name="true"
        :show-user-name="false"
        :show-tooltip="true"
      />

      <template v-if="getActionAvailabilityFlag(ACTION_ENUM.TOGGLE_AUTO_MERGE)">
        <button
          v-if="mergeRequest.autoMergeDisable && !mergeRequest.autoMergeAllowed && mergeRequest.autoMergeEnabled"
          class="btn btn-sm merge-request-auto-merge-info__cancel ml-0 ml-md-auto font-weight-bolder"
          @click="toggleAutoMerge"
        >
          <span class="text-danger">
            {{ $t('page.autoMergeDisable') }}
          </span>
        </button>

        <button
          v-if="mergeRequest.autoMergeAllowed && !mergeRequest.autoMergeDisable && !mergeRequest.autoMergeEnabled"
          class="btn btn-sm merge-request-auto-merge-info__cancel ml-0 ml-md-auto font-weight-bolder"
          @click="toggleAutoMerge"
        >
          <span class="text-success">
            {{ $t('page.autoMergeEnable') }}
          </span>
        </button>

        <button
          class="btn btn-sm merge-request-auto-merge-info__cancel ml-0 ml-md-auto font-weight-bolder"
          v-if="mergeRequest.autoMergeDisable && mergeRequest.autoMergeAllowed"
          @click="toggleAutoMerge"
        >
          <span
            v-if="mergeRequest.autoMergeEnabled && mergeRequest.autoMergeDisable"
            class="text-danger"
          >
            {{ $t('page.autoMergeDisable') }}
          </span>
          <span
            v-if="!mergeRequest.autoMergeEnabled && mergeRequest.autoMergeAllowed"
            class="text-success"
          >
            {{ $t('page.autoMergeEnable') }}
          </span>
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import userLabelItem from '../../../shared-components/shared/user-label-item.vue';
import langMessages from '../merge-request-auto-merge.messages';
import autoMergeService from '../merge-request-auto-merge.service';
import ACTION_ENUM from "@shared/modules/custom-roles/custom-roles.constants";
import referenceService from "@shared/services/reference.service";
export default {
  computed: {
    ACTION_ENUM() {
      return ACTION_ENUM
    }
  },
  components: { userLabelItem },
  data() {
    return {
      localAutoMergeEnabled: this.mergeRequest.autoMergeEnabled,
      localAutoMergeAllowed: this.mergeRequest.autoMergeAllowed,
      localAutoMergeDisable: this.mergeRequest.autoMergeDisable
    };
  },
  props: {
    user: null,
    mergeRequest: {
      type: Object,
      default: null
    }
  },
  i18n: {
    messages: langMessages
  },
  mounted() {
  },
  methods: {
    toggleAutoMerge() {
      this.localAutoMergeEnabled = !this.localAutoMergeEnabled;
      autoMergeService.cancelAutoMergeForMergeRequestItem(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.$route.params.id,
        this.localAutoMergeEnabled
      );
      this.$emit('toggle');
    },
    getActionAvailabilityFlag(action) {
      return this.$store.getters.getActionAvailabilityFlag(action);
    },
  }
};
</script>

<style lang="scss" scoped>
.merge-request-auto-merge-info {
  &__wrapper {
    border: 1px solid var(--border-color);
    border-radius: 0.25rem;
  }
  &__cancel {
    cursor: pointer;
    user-select: none;
  }
}
</style>
